/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-14 00:01:53
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductDraggableDisplay/ImgAndSkuShortDisplay/index.tsx
 */
/**
 *  Product Draggable
 *  Author: Luke
 *  CreatedAt: 2021-03-05
 */
import React from 'react';

//import css from './SalesChannelEditorPromotion.less';

import DragNDropColumns from 'src/components/DragNDropColumns';
import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const ProductDraggableDisplay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  const {
    droppableId,
    data,
    onChange,
    onSort,
    onDelete,
    onDeleteAll,
    displayWarningModalWhenDeleting,
    warningModalTitle,
    warningModalContent,
    hideTitleRightFunction,
    salesChannelUuid,
  } = props;
  const childGenerate = (data, index) => {
    const { sku, name, thumbnailUrl } = data || {};
    return <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />;
  };
  const onCancel = () => {
    setVisible(false);
  };
  const onAdd = () => {
    setVisible(true);
  };
  const onOk = (products = []) => {
    const _pWithDraggableId = products.map((i) => {
      const { uuid } = i;
      return { ...i, draggableId: uuid };
    });
    onChange(_pWithDraggableId);
  };
  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) onSort(oldIndex, newIndex);
  };
  const _onDelete = (index) => {
    if (onDelete) onDelete(index);
  };
  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedProducts={data}
          disabledProducts={[]}
          salesChannelUuid={salesChannelUuid}
        />
      )}

      <DragNDropColumns
        warningModalTitle={warningModalTitle}
        warningModalContent={warningModalContent}
        displayWarningModalWhenDeleting={displayWarningModalWhenDeleting}
        title={getI18n('general.products')}
        titleRightFunction={onDeleteAll}
        titleRightText={getI18n('general.dragNDropColumns.delete_all')}
        childGenerate={childGenerate}
        onDelete={_onDelete}
        data={data}
        droppableId={droppableId}
        onSort={_onSort}
        onAdd={onAdd}
        addText={`+ ${getI18n('general.addProducts')}`}
        hideTitleRightFunction={hideTitleRightFunction}
      />
    </React.Fragment>
  );
};
export default ProductDraggableDisplay;
